// One color per project, cycled deterministically by id — same project always gets the same
// dot color across renders/sessions without a stored "project color" column. Palette matches
// requirements/ui/home page/README.md's "Project color-coding (example set)".
const PALETTE = ['#00ADEF', '#423699', '#0A8F3D', '#EF6513', '#19B7B8'];

export function projectColor(projectId: string): string {
  let hash = 0;
  for (let i = 0; i < projectId.length; i += 1) {
    hash = (hash * 31 + projectId.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length] ?? PALETTE[0] ?? '#00ADEF';
}
